import {useUserProperty} from 'src/api/lib/UserProperties/useUserProperty'

export const useGetSelectedCardOfferId = (): string | undefined => {
  const {value: workflowState} = useUserProperty('workflowState')
  return workflowState?.selectedOffer?.offerId
}
